import { render, staticRenderFns } from "./Coding.vue?vue&type=template&id=025407df&scoped=true"
import script from "./Coding.vue?vue&type=script&lang=js"
export * from "./Coding.vue?vue&type=script&lang=js"
import style0 from "./Coding.vue?vue&type=style&index=0&id=025407df&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025407df",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('025407df')) {
      api.createRecord('025407df', component.options)
    } else {
      api.reload('025407df', component.options)
    }
    module.hot.accept("./Coding.vue?vue&type=template&id=025407df&scoped=true", function () {
      api.rerender('025407df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bookkeeping/Coding.vue"
export default component.exports